module.exports = __webpack_public_path__ + "img/tramite.8a2e098e.svg";